import { render, staticRenderFns } from "./SalesTaxList.vue?vue&type=template&id=064c71c4&scoped=true"
import script from "./SalesTaxList.vue?vue&type=script&lang=js"
export * from "./SalesTaxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064c71c4",
  null
  
)

export default component.exports